








import { defineComponent } from '@nuxtjs/composition-api'
import { Fluorescent } from '@/types/product/productTypes'

export default defineComponent({
  props: {
    fluorescentProperties: {
      type: Array as () => Fluorescent[],
      required: false,
      default: undefined,
    },
  },
  setup() {
    return {}
  },
})
